import { extensions } from '../../extensions/Extensions.mjs';
import { HTMLTextPipe } from './HTMLTextPipe.mjs';
import { HTMLTextSystem } from './HTMLTextSystem.mjs';

"use strict";
extensions.add(HTMLTextSystem);
extensions.add(HTMLTextPipe);
//# sourceMappingURL=init.mjs.map
